// Task types for Supabase integration
export type TaskStatus = "pending" | "processing" | "finished" | "error" | "expired";

export interface Task {
  id: string;
  user_id: string;
  project_id: string | null;
  status: TaskStatus;
  product_name: string;
  product_description: string | null;
  input_image_url: string | null;
  image_generated_url: string | null;
  prompt_persona: Record<string, unknown> | null;
  prompts: Record<string, unknown> | null;
  prompt_array: Array<{ index: number; script: string }> | null;
  flux_images: Array<{ url: string; frame: number }> | null;
  kie_video_tasks: Array<{ index: number; status: string; video_url: string | null; kie_task_id: string | null }> | null;
  video_assets: Array<{ id: number; url: string; thumbnail: string; duration: number }> | null;
  error_message: string | null;
  expires_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface TaskLog {
  id: number;
  task_id: string;
  user_id: string;
  step: string;
  message: string | null;
  data: Record<string, unknown> | null;
  created_at: string;
}

// Helper to format dates
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Helper to get video count from task
export function getVideoCount(task: Task): number {
  return task.video_assets?.length ?? 0;
}

// Helper to check if a task is expired (older than 3 days)
export function isTaskExpired(task: Task): boolean {
  if (task.expires_at) {
    return new Date(task.expires_at) < new Date();
  }
  // Fallback: check if created_at is older than 3 days
  const threeDaysMs = 3 * 24 * 60 * 60 * 1000;
  return new Date(task.created_at).getTime() + threeDaysMs < Date.now();
}

// Helper to get thumbnail from task
export function getTaskThumbnail(task: Task): string {
  if (task.video_assets?.[0]?.thumbnail) {
    return task.video_assets[0].thumbnail;
  }
  if (task.input_image_url) {
    return task.input_image_url;
  }
  return "https://placehold.co/400x400/1a1a1a/14b8a6?text=Sem+Imagem";
}
